import React from 'react';

interface HomeIconProps {
    readonly color?: string;
    readonly size?: number;
}

export default function HomeIconV2({ color = '#253858', size = 16 }: HomeIconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.5293 6.44922V13.1396H6.1416V8.66699H9.8584V13.1396H12.4717V6.44922L8 3.0752L3.5293 6.44922ZM13.4336 14.0996H8.89648V9.62695H7.10352V14.0996H2.56738V5.96973L2.60645 5.93945L7.94043 1.91992L8 1.875L8.06055 1.91992L13.3936 5.93945L13.4336 5.96973V14.0996Z" fill={color} stroke={color} strokeWidth="0.2" />
        </svg>
    )
}
